import {Injectable} from '@angular/core';
import {AdminUser} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class AdminUsersService extends TableOptionsService<AdminUser> {
    constructor() {
        super();
    }

    public override matches(element: AdminUser, term: string) {
        return (
            element.fullName?.toLowerCase().includes(term.toLowerCase()) ||
            element.email?.toLowerCase().includes(term.toLowerCase())
        );
    }
}